export default __webpack_public_path__ + "src/assets/icn-toast-error.6c1e1f9d79c3a11340028c8e481d4483.svg";